import script from "./BulkParsing.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkParsing.vue?vue&type=script&setup=true&lang=js"

import "./BulkParsing.vue?vue&type=style&index=0&id=26aab6bc&lang=scss&scoped=true"
import "./BulkParsing.vue?vue&type=style&index=1&id=26aab6bc&lang=scss"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26aab6bc"]])

export default __exports__